module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-36x36-57ff586245bcc876321d34f4a7374ff5.png";